import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {


  @ViewChild("imprintModal") imprintModal : ElementRef;

  @ViewChild("privacyModal") privacyModal : ElementRef;

  @Input()
  background : string;
  currentDate = new Date();
  
  openModal: any;

  constructor(private modals: NgbModal) { }

  ngOnInit() {
  }

  showImprint() {
    this.showModal(this.imprintModal, "lg").result.then(
      (result) => {
      },
      (reason) => {
      });
  }

  showModal(modal : ElementRef, size : string) {
    if (this.openModal) this.openModal.close();    
    this.openModal = this.modals.open(modal, { size: "lg"});
    return this.openModal;
  }
}